import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import './FraudPreventionInformation.scss'

export const FraudPreventionInformation = () => {
    const { t } = useTranslation()

    return (
        <div className="fraud-prevention-information">
            <h2>{t('FraudPreventionInformation')}</h2>

            <div className="fraud-prevention-information-text">
                <Trans
                    i18nKey="FraudPreventionInformationDescription"
                    components={{
                        privacyNotice: (
                            <a
                                href="https://google.com"
                                target="_blank"
                                rel="noreferrer"
                            />
                        ),
                    }}
                />
            </div>
        </div>
    )
}